import React from "react";

import { IconTraces } from "~/components/icon";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { TRACES_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const TracesBreadcrumb: React.FC = () => {
	const link = useNavigateToLink(TRACES_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <BreadcrumbLayout icon={<IconTraces className={BREADCRUMB_ICON_CLASS} />} label="Traces" to={link} />;
};
